const HEADER_MENU = {
  name: 'header_menu',
  type: 'HEADER_MENU',
  prefixKey: 'hmn',
  priority: 4
}
const PAGE = {
  name: 'page',
  type: 'PAGE',
  prefixKey: 'pge',
  priority: 4
}

const SECTION_TYPE_NONE_SETTING = [
  "SECTION_PAGE_INFORM_PAYMENT",
  "SECTION_PAGE_ONLINE_PAYMENT",
  "SECTION_PAGE_TERMS_CONDITION",
  "SECTION_PAGE_ORDER_TRACKING",
  "SECTION_PAGE_SEARCH",
]

const WIDGET_TYPE_NONE_SETTING = [
  "SYSTEM_WIDGET_TEXT",
]

//Page Config
const PAGE_PRODUCT_CONFIG = {
  name: 'page_product_config',
  type: 'PAGE_PRODUCT',
  staticKey: 'PAGE_PRODUCT',
}
const PAGE_PRODUCT_ITEM_CONFIG = {
  name: 'page_product_item_config',
  type: 'PAGE_PRODUCT_ITEM',
  staticKey: 'PAGE_PRODUCT_ITEM',
}
const PAGE_CONTENT_CONFIG = {
  name: 'page_content_config',
  type: 'PAGE_CONTENT',
  staticKey: 'PAGE_CONTENT',
}

const PAGE_CONTENT_ITEM_CONFIG = {
  name: 'page_content_item_config',
  type: 'PAGE_CONTENT_ITEM',
  staticKey: 'PAGE_CONTENT_ITEM',
}
const PAGE_PRODUCT_BRAND_CONFIG = {
  name: 'page_product_brand_config',
  type: 'PAGE_PRODUCT_BRAND_CONFIG',
  staticKey: 'PAGE_PRODUCT_BRAND_CONFIG',
}
const PAGE_CONTACT_CONFIG = {
  name: 'page_contact_config',
  type: 'PAGE_CONTACT_CONFIG',
  staticKey: 'PAGE_CONTACT_CONFIG',
}
const PAGE_FORM_ITEM_CONFIG = {
  name: 'page_form_item_config',
  type: 'PAGE_FORM_ITEM_CONFIG',
  staticKey: 'PAGE_FORM_ITEM_CONFIG',
}
const PAGE_FAQ_CONFIG = {
  name: 'page_faq_config',
  type: 'PAGE_FAQ_CONFIG',
  staticKey: 'PAGE_FAQ_CONFIG',
}
const PAGE_EVENT_CALENDAR_ITEM_CONFIG = {
  name: 'page_event_calendar_item_config',
  type: 'PAGE_EVENT_CALENDAR_ITEM_CONFIG',
  staticKey: 'PAGE_EVENT_CALENDAR_ITEM_CONFIG',
}
const PAGE_QUOTATION_FORM_ITEM_CONFIG = {
  name: 'page_quotation_form_item_config',
  type: 'PAGE_QUOTATION_FORM_ITEM_CONFIG',
  staticKey: 'PAGE_QUOTATION_FORM_ITEM_CONFIG',
}


// Section page
const SECTION_PAGE_PRODUCT = {
  name: 'section_page_product',
  type: 'SECTION_PAGE_PRODUCT',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_CONTENT = {
  name: 'section_page_content',
  type: 'SECTION_PAGE_CONTENT',
  staticKey: 'SECTION_PAGE',
}

const SECTION_PAGE_CONTENT_ITEM = {
  name: 'section_page_content_item',
  type: 'SECTION_PAGE_CONTENT_ITEM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_ALBUM = {
  name: 'section_page_album',
  type: 'SECTION_PAGE_ALBUM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_ALBUM_ITEM = {
  name: 'section_page_album_item',
  type: 'SECTION_PAGE_ALBUM_ITEM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_TERMS_CONDITION = {
  name: 'section_page_terms_condition',
  type: 'SECTION_PAGE_TERMS_CONDITION',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_PRODUCT_BRAND = {
  name: 'section_page_product_brand',
  type: 'SECTION_PAGE_PRODUCT_BRAND',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_GIFTCARD = {
  name: 'section_page_giftcard',
  type: 'SECTION_PAGE_GIFTCARD',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_INFORM_PAYMENT = {
  name: 'section_page_inform_payment',
  type: 'SECTION_PAGE_INFORM_PAYMENT',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_SEARCH = {
  name: 'section_page_search',
  type: 'SECTION_PAGE_SEARCH',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_PRODUCT_ITEM = {
  name: 'section_page_product_item',
  type: 'SECTION_PAGE_PRODUCT_ITEM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_FORM_ITEM = {
  name: 'section_page_form_item',
  type: 'SECTION_PAGE_FORM_ITEM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_ONLINE_PAYMENT = {
  name: 'section_page_online_payment',
  type: 'SECTION_PAGE_ONLINE_PAYMENT',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_CONTACT = {
  name: 'section_page_contact',
  type: 'SECTION_PAGE_CONTACT',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_ORDER_TRACKING = {
  name: 'section_page_order_tracking',
  type: 'SECTION_PAGE_ORDER_TRACKING',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_FAQ = {
  name: 'section_page_faq',
  type: 'SECTION_PAGE_FAQ',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_EVENT_CALENDAR = {
  name: 'section_page_event_calendar',
  type: 'SECTION_PAGE_EVENT_CALENDAR',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_EVENT_CALENDAR_ITEM = {
  name: 'section_page_event_calendar_item',
  type: 'SECTION_PAGE_EVENT_CALENDAR_ITEM',
  staticKey: 'SECTION_PAGE',
}
const SECTION_PAGE_QUOTATION_FORM_ITEM = {
  name: 'section_page_quotation_form_item',
  type: 'SECTION_PAGE_QUOTATION_FORM_ITEM',
  staticKey: 'SECTION_PAGE',
}

const SECTION_PAGE_POLICY = {
  name: 'section_page_policy',
  type: 'SECTION_PAGE_POLICY',
  staticKey: 'SECTION_PAGE',
}

// Style page 
const SECTION_PAGE_CONTENT_STYLE = {
  name: 'style_page_content',
  type: 'page_content',
  staticKey: 'STYLE_PAGE_CONTENT',
}
const SECTION_PAGE_CONTENT_ITEM_STYLE = {
  name: 'section_page_content_item',
  type: 'page_content_item',
  staticKey: 'STYLE_PAGE_CONTENT',
}
const SECTION_PAGE_ALBUM_ITEM_STYLE = {
  name: 'section_page_album_item',
  type: 'page_album_item',
  staticKey: 'STYLE_PAGE_ALBUM',
}
const SECTION_PAGE_ALBUM_STYLE = {
  name: 'style_page_album',
  type: 'page_album',
  staticKey: 'STYLE_PAGE_ALBUM',
}
const SECTION_PAGE_CONTACT_STYLE = {
  name: 'style_page_contact',
  type: 'page_contact',
  staticKey: 'STYLE_PAGE_CONTACT',
}
const SECTION_PAGE_FORM_ITEM_STYLE = {
  name: 'style_page_form_item',
  type: 'page_form_item',
  staticKey: 'STYLE_PAGE_FORM_ITEM',
}
const SECTION_PAGE_PRODUCT_ITEM_STYLE = {
  name: 'style_page_product_item',
  type: 'page_product_item',
  staticKey: 'STYLE_PAGE_PRODUCT_ITEM',
}
const SECTION_PAGE_FAQ_STYLE = {
  name: 'style_page_faq',
  type: 'page_faq',
  staticKey: 'STYLE_PAGE_FAQ',
}
const SECTION_PAGE_EVENT_CALENDAR_ITEM_STYLE = {
  name: 'style_page_event_calendar_item',
  type: 'page_event_calendar_item',
  staticKey: 'STYLE_PAGE_EVENT_CALENDAR_ITEM',
}
const SECTION_PAGE_QUOTATION_FORM_ITEM_STYLE = {
  name: 'style_page_quotation_form_item',
  type: 'page_quotation_form_item',
  staticKey: 'STYLE_PAGE_QUOTATION_FORM_ITEM',
}


const HEADER_WIDGET = {
  name: 'header_widget',
  type: 'HEADER_WIDGET',
  prefixType: 'HEADER_WIDGET_',
  prefixKey: 'HEADER_WIDGET_',
  priority: 4
}
const FOOTER_WIDGET = {
  name: 'footer_widget',
  type: 'FOOTER_WIDGET',
  prefixType: 'FOOTER_WIDGET_',
  prefixKey: 'FOOTER_WIDGET_',
  priority: 4
}
const SECTION = {
  name: 'section',
  type: 'SECTION',
  prefixKey: 'sec',
  priority: 4
}
const GRID = {
  name: 'grid',
  type: 'SECTION_GRID',
  prefixKey: 'grd',
  priority: 3
}
const CELL = {
  name: 'cell',
  type: 'SECTION_CELL',
  prefixKey: 'cll',
  priority: 2
}
const WIDGET = {
  name: 'widget',
  prefixType: 'SECTION_WIDGET_',
  prefixKey: 'wdg',
  priority: 1,
}
const SYSTEM_WIDGET = {
  name: 'systemWidget',
  prefixType: 'SYSTEM_WIDGET_',
  prefixKey: 'wdg',
  priority: 1,
}
const SLIDE_ITEM = {
  name: 'slideItem',
  prefixKey: 'sli',
  prefixType: 'SLIDE_ITEM',
  priority: 1
}
const SLIDE_BLOCK = {
  name: 'slideBlock',
  prefixKey: 'slb',
  prefixType: 'SLIDE_BLOCK',
  priority: 1
}

const SLIDE_SECTION = {
  name: 'slideSection',
  type: 'SLIDE_SECTION',
  prefixKey: 'sec',
  priority: 4
}
const SLIDE_PAGE = {
  name: 'slidePage',
  type: 'SLIDE_PAGE',
  prefixKey: 'slp',
  priority: 3
}
const SLIDE_CONTAINER = {
  name: 'slideContainer',
  type: 'SLIDE_CONTAINER',
  prefixKey: 'slc',
  priority: 2
}

export {
  HEADER_MENU,
  HEADER_WIDGET,
  FOOTER_WIDGET,
  PAGE,
  PAGE_PRODUCT_CONFIG,
  PAGE_PRODUCT_ITEM_CONFIG,
  PAGE_CONTENT_CONFIG,
  PAGE_CONTENT_ITEM_CONFIG,
  PAGE_PRODUCT_BRAND_CONFIG,
  PAGE_CONTACT_CONFIG,
  PAGE_FORM_ITEM_CONFIG,
  PAGE_FAQ_CONFIG,
  PAGE_EVENT_CALENDAR_ITEM_CONFIG,
  PAGE_QUOTATION_FORM_ITEM_CONFIG,


  SECTION_PAGE_ALBUM_ITEM_STYLE,
  SECTION_PAGE_CONTENT_ITEM_STYLE,
  SECTION_PAGE_ALBUM_STYLE,
  SECTION_PAGE_CONTENT_STYLE,
  SECTION_PAGE_CONTACT_STYLE,
  SECTION_PAGE_FORM_ITEM_STYLE,
  SECTION_PAGE_PRODUCT_ITEM_STYLE,
  SECTION_PAGE_FAQ_STYLE,
  SECTION_PAGE_EVENT_CALENDAR_ITEM_STYLE,
  SECTION_PAGE_QUOTATION_FORM_ITEM_STYLE,

  SECTION_PAGE_ALBUM_ITEM,
  SECTION_PAGE_TERMS_CONDITION,
  SECTION_PAGE_PRODUCT_BRAND,
  SECTION_PAGE_GIFTCARD,
  SECTION_PAGE_PRODUCT,
  SECTION_PAGE_CONTENT,
  SECTION_PAGE_CONTENT_ITEM,
  SECTION_PAGE_ALBUM,
  SECTION_PAGE_INFORM_PAYMENT,
  SECTION_PAGE_PRODUCT_ITEM,
  SECTION_PAGE_FORM_ITEM,
  SECTION_PAGE_ONLINE_PAYMENT,
  SECTION_PAGE_CONTACT,
  SECTION_PAGE_ORDER_TRACKING,
  SECTION_PAGE_FAQ,
  SECTION_PAGE_EVENT_CALENDAR,
  SECTION_PAGE_EVENT_CALENDAR_ITEM,
  SECTION_PAGE_POLICY,
  SECTION_PAGE_QUOTATION_FORM_ITEM,
  SECTION_PAGE_SEARCH,

  SLIDE_ITEM,
  SLIDE_BLOCK,

  SECTION_TYPE_NONE_SETTING,
  WIDGET_TYPE_NONE_SETTING,

  SECTION,
  GRID,
  CELL,
  WIDGET,
  SYSTEM_WIDGET,
  SLIDE_SECTION,
  SLIDE_PAGE,
  SLIDE_CONTAINER,
}
export default {
  HEADER_MENU,
  HEADER_WIDGET,
  PAGE,
  PAGE_PRODUCT_CONFIG,
  PAGE_PRODUCT_ITEM_CONFIG,
  PAGE_CONTENT_CONFIG,
  PAGE_CONTENT_ITEM_CONFIG,
  PAGE_PRODUCT_BRAND_CONFIG,
  PAGE_CONTACT_CONFIG,
  PAGE_FORM_ITEM_CONFIG,
  PAGE_FAQ_CONFIG,
  PAGE_EVENT_CALENDAR_ITEM_CONFIG,
  PAGE_QUOTATION_FORM_ITEM_CONFIG,


  SECTION_PAGE_ALBUM_ITEM_STYLE,
  SECTION_PAGE_CONTENT_ITEM_STYLE,
  SECTION_PAGE_ALBUM_STYLE,
  SECTION_PAGE_CONTENT_STYLE,
  SECTION_PAGE_CONTACT_STYLE,
  SECTION_PAGE_FORM_ITEM_STYLE,
  SECTION_PAGE_PRODUCT_ITEM_STYLE,
  SECTION_PAGE_FAQ_STYLE,
  SECTION_PAGE_EVENT_CALENDAR_ITEM_STYLE,
  SECTION_PAGE_QUOTATION_FORM_ITEM_STYLE,


  SECTION_PAGE_ALBUM_ITEM,
  SECTION_PAGE_TERMS_CONDITION,
  SECTION_PAGE_PRODUCT_BRAND,
  SECTION_PAGE_GIFTCARD,
  SECTION_PAGE_PRODUCT,
  SECTION_PAGE_CONTENT,
  SECTION_PAGE_CONTENT_ITEM,
  SECTION_PAGE_ALBUM,
  SECTION_PAGE_INFORM_PAYMENT,
  SECTION_PAGE_PRODUCT_ITEM,
  SECTION_PAGE_ONLINE_PAYMENT,
  SECTION_PAGE_CONTACT,
  SECTION_PAGE_ORDER_TRACKING,
  SECTION_PAGE_FAQ,
  SECTION_PAGE_EVENT_CALENDAR,
  SECTION_PAGE_EVENT_CALENDAR_ITEM,
  SECTION_PAGE_POLICY,
  SECTION_PAGE_QUOTATION_FORM_ITEM,
  SECTION_PAGE_SEARCH,

  SLIDE_ITEM,
  SLIDE_BLOCK,

  SECTION_TYPE_NONE_SETTING,
  WIDGET_TYPE_NONE_SETTING,

  SECTION,
  GRID,
  CELL,
  WIDGET,
  SYSTEM_WIDGET,
  SLIDE_SECTION,
  SLIDE_PAGE,
  SLIDE_CONTAINER,
}